<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-clipboard-list"
        texto-titulo="Editar Liquidación"
      />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h4 class="">
                    {{ liquidacion.periodo }} -
                    {{ liquidacion.tipo_liquidacion }}
                  </h4>
                  <div
                    class="row pt-3"
                    style="max-height: 500px; overflow-y: auto"
                  >
                    <div class="col-lg-12">
                      <div class="mb-3 col-12">
                        <div class="row">
                          <div class="col-md-6 col-12 form-group input-group">
                            <input type="text" class="form-control form-control-sm" placeholder="Buscar.." v-model="params.search"/>
                            <span class="input-group-append">
                              <button type="button" class="btn btn-sm btn-primary">
                                <i class="fas fa-search"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <ul
                            class="list-group list-group-flush mb-3"
                            v-if="searching"
                          >
                            <li class="list-group-item">
                              <div class="skeleton">
                                <div class="skeleton-author"></div>
                                <div class="skeleton-content"></div>
                                <div class="skeleton-content"></div>
                              </div>
                            </li>
                            <li class="list-group-item">
                              <div class="skeleton">
                                <div class="skeleton-author"></div>
                                <div class="skeleton-content"></div>
                                <div class="skeleton-content"></div>
                              </div>
                            </li>
                          </ul>
                          <ul
                            class="list-group list-group-flush mb-3"
                            v-else-if="recibos.length == 0"
                          >
                            <li class="list-group-item">
                              <h5 class="text-center">
                                No se encontraron resultados
                              </h5>
                            </li>
                          </ul>
                          <ul
                            class="list-group list-group-flush mb-3 col-12"
                            v-else
                          >
                            <li
                              class="list-group-item hoverable"
                              v-for="(recibo, i) in recibosFiltrados"
                              :key="i"
                              @click="verRecibo(recibo)"
                            >
                              <div class="widget-content p-0">
                                <div class="widget-content-wrapper row">
                                  <div class="widget-content-left col-12">
                                    <h5 class="widget-heading">
                                      <span class="text-primary">
                                        <span>{{ recibo.nombre }}</span>
                                      </span>
                                    </h5>
                                    <div
                                      class="widget-subheading opacity-10 row"
                                    >
                                      <span class="col-sm-auto col-12 row">
                                        <span
                                          class="text-left col-sm-auto col-12"
                                        >
                                          Legajo N°
                                          <b class="text-alternate">{{
                                            recibo.numero_legajo
                                          }}</b>
                                        </span>
                                        <span
                                          class="text-left col-sm-auto col-12"
                                        >
                                          <b class="text-alternate"
                                            >{{ recibo.per_dep }} -
                                            {{ recibo.mensual_jornal }}</b
                                          >
                                        </span>
                                        <span
                                          class="text-left col-sm-auto col-12"
                                        >
                                          Seccion:
                                          <b class="text-alternate">{{
                                            recibo.seccion
                                          }}</b>
                                        </span>
                                        <span
                                          class="ml-lg-3 text-left col-sm-auto col-12"
                                        >
                                          Neto:
                                          <b class="text-alternate">
                                            $ {{ recibo.neto }}</b
                                          >
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 row d-flex justify-content-end mt-2">
                    <router-link class="btn btn-primary" :to="{name:'VerLiquidacion', params:{id: params.liquidacion_id}}">
                      Guardar Liquidiacion
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import axios from "axios";
import Swal from "sweetalert2";
import Liquidacion from "@/models/liquidacion";
export default {
  name: "EditarLiquidacion",
  components: {
    TituloComponente,
  },
  data() {
    return {
      liquidacion: new Liquidacion(null, null, null, null),
      recibos:[],
      enviado: false,
      searching: false,
      params:{
        search: "",
        liquidacion_id: null,
        paginate:false
      },
    };
  },
  created() {
    this.params.liquidacion_id = this.$route.params.id;
    this.getRecibos();
  },
  mounted() {
  },
  computed: {
    recibosFiltrados: function(){
      let filtro = [...this.recibos];
        if(this.params.search == ''){
            return filtro;
        }
        return filtro.filter( 
            function(item){
                return item.nombre.toUpperCase().includes(this.params.search.toUpperCase())
                }.bind(this)
            );
    }
  },
  methods: {
    getRecibos() {
      this.loading = true;
      axios
        .get("recibo/", {params:this.params})
        .then((res) => {
          //console.log(res.data);
          //if (res.data.success) {
            console.log(res.data.liquidacion);
            this.recibos = res.data.recibo.data;
            this.liquidacion = res.data.liquidacion;
            this.recibos.sort(function (a, b) {
              if (a.nombre > b.nombre) {
                return 1;
              }
              if (a.nombre < b.nombre) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
        //  }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado Recibos.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    verRecibo(recibo) {
      this.$router.push({ name: "EditarRecibo", params: { id: recibo.id } });
    },
    search_query() {
      clearTimeout(this.timer); 
      this.timer = setTimeout(() => {
        this.params.page = 1;
        this.getRecibos();
      }, 1000)
    },
  },
};
</script>